// Centralized song catalogue — 18 songs
// All paths are relative to /songs/ (served from public/)

const musicData = [
  {
    id: "kiss-n-crave",
    title: "Kiss n Crave",
    artworkUrl: "/songs/artworks/kiss-n-crave.png",
    audioUrl: "/songs/audio/kiss-n-crave.mp3",
    karaokeUrl: "/songs/karaoke-audio/kiss-n-crave.mp3",
    lyricsFile: "kiss_n_crave.md",
    timedLyricsFile: "Kiss n Crave - DeNyx.lrc",
    hasKaraoke: false,
    duration: "3:03",
  },
  {
    id: "beautier-than-the-night",
    title: "Beautier Than The Night",
    artworkUrl: "/songs/artworks/beautier-than-the-night.png",
    audioUrl: "/songs/audio/beautier-than-the-night.mp3",
    karaokeUrl: "/songs/karaoke-audio/beautier-than-the-night.mp3",
    lyricsFile: "beautier_than_the_night.md",
    timedLyricsFile: "Beautier Than The Night - DeNyx.lrc",
    hasKaraoke: false,
    duration: "2:35",
  },
  {
    id: "quest-start",
    title: "Quest: Start",
    artworkUrl: "/songs/artworks/quest-start.png",
    audioUrl: "/songs/audio/quest-start.mp3",
    karaokeUrl: "/songs/karaoke-audio/quest-start.mp3",
    lyricsFile: "quest_start.md",
    timedLyricsFile: "Quest_ Start - DeNyx.lrc",
    hasKaraoke: true,
    duration: "3:05",
  },
  {
    id: "girls-are-weird",
    title: "GirLs aRe WEirD :P",
    artworkUrl: "/songs/artworks/girls-are-weird.jpg",
    audioUrl: "/songs/audio/girls-are-weird.mp3",
    karaokeUrl: "/songs/karaoke-audio/girls-are-weird.mp3",
    lyricsFile: "girls_are_weird.md",
    timedLyricsFile: "GirLs aRe WEirD _P - DeNyx.lrc",
    hasKaraoke: true,
    duration: "2:59",
  },
  {
    id: "guzelsin-sen-geceden",
    title: "Güzelsin Sen Geceden",
    artworkUrl: "/songs/artworks/guzelsin-sen-geceden.png",
    audioUrl: "/songs/audio/guzelsin-sen-geceden.mp3",
    karaokeUrl: "/songs/karaoke-audio/guzelsin-sen-geceden.mp3",
    lyricsFile: "guzelsin_sen_geceden.md",
    timedLyricsFile: "Güzelsin Sen Geceden - DeNyx.lrc",
    hasKaraoke: true,
    duration: "3:56",
  },
  {
    id: "give-me-h",
    title: "give me h-",
    artworkUrl: "/songs/artworks/give-me-head.png",
    audioUrl: "/songs/audio/give-me-head.mp3",
    karaokeUrl: "/songs/karaoke-audio/give-me-head.mp3",
    lyricsFile: "give_me_h.md",
    timedLyricsFile: "give me h- - DeNyx.lrc",
    hasKaraoke: true,
    duration: "2:57",
  },
  {
    id: "istanbulwave",
    title: "IstanbulWave",
    artworkUrl: "/songs/artworks/istanbulwave.png",
    audioUrl: "/songs/audio/istanbulwave.mp3",
    karaokeUrl: "/songs/karaoke-audio/istanbulwave.mp3",
    lyricsFile: "istanbulwave.md",
    timedLyricsFile: "IstanbulWave - DeNyx.lrc",
    hasKaraoke: true,
    duration: "3:28",
  },
  {
    id: "kiss-me-when-out",
    title: "Kiss me when we're finally ouT",
    artworkUrl: "/songs/artworks/kiss-me-when-we're-finally-out.png",
    audioUrl: "/songs/audio/kiss-me-when-we're-finally-out.mp3",
    karaokeUrl: "/songs/karaoke-audio/kiss-me-when-we're-finally-out.mp3",
    lyricsFile: "kiss_me_when_out.md",
    timedLyricsFile: "kiss me when the time comes - DeNyx.lrc",
    hasKaraoke: true,
    duration: "3:25",
  },
  {
    id: "nebula",
    title: "Nebula (feat. Güzey)",
    artworkUrl: "/songs/artworks/nebula.png",
    audioUrl: "/songs/audio/nebula.mp3",
    karaokeUrl: "/songs/karaoke-audio/nebula.mp3",
    lyricsFile: "nebula.md",
    timedLyricsFile: null,
    hasKaraoke: true,
    duration: "2:35",
  },
  {
    id: "bi-guzel-dus",
    title: "Bi' Güzel Düş...",
    artworkUrl: "/songs/artworks/bi-guzel-dus.png",
    audioUrl: "/songs/audio/bi-guzel-dus.mp3",
    karaokeUrl: "/songs/karaoke-audio/bi-guzel-dus.mp3",
    lyricsFile: "bi_guzel_dus.md",
    timedLyricsFile: null,
    hasKaraoke: true,
    duration: "2:47",
  },
  {
    id: "i-didnt-want-a-war",
    title: "I Didn't Want a War on Her Smile",
    artworkUrl: "/songs/artworks/i-didn't-want-a-war-on-her-smile.png",
    audioUrl: "/songs/audio/i-didn't-want-a-war-on-her-smile.mp3",
    karaokeUrl: "/songs/karaoke-audio/i-didn't-want-a-war-on-her-smile.mp3",
    lyricsFile: "i_didnt_want_a_war.md",
    timedLyricsFile: null,
    hasKaraoke: true,
    duration: "3:04",
  },
  {
    id: "in-iceland",
    title: "In Iceland",
    artworkUrl: "/songs/artworks/in-iceland.png",
    audioUrl: "/songs/audio/in-iceland.mp3",
    karaokeUrl: "/songs/karaoke-audio/in-iceland.mp3",
    lyricsFile: "in_iceland.md",
    timedLyricsFile: null,
    hasKaraoke: false,
    duration: "1:57",
  },
  {
    id: "karanlikta",
    title: "Karanlıkta (feat. Güzey)",
    artworkUrl: "/songs/artworks/karanlikta.png",
    audioUrl: "/songs/audio/karanlikta.mp3",
    karaokeUrl: "/songs/karaoke-audio/karanlikta.mp3",
    lyricsFile: "karanlikta.md",
    timedLyricsFile: null,
    hasKaraoke: false,
    duration: "2:47",
  },
  {
    id: "kos-kostur",
    title: "Koş Koştur (feat. Güzey)",
    artworkUrl: "/songs/artworks/kos-kostur.png",
    audioUrl: "/songs/audio/kos-kostur.mp3",
    karaokeUrl: "/songs/karaoke-audio/kos-kostur.mp3",
    lyricsFile: "kos_kostur.md",
    timedLyricsFile: null,
    hasKaraoke: true,
    duration: "2:05",
  },
  {
    id: "minik-minik-elleri",
    title: "Minik Minik Elleri",
    artworkUrl: "/songs/artworks/minik-minik-elleri.png",
    audioUrl: "/songs/audio/minik-minik-elleri.mp3",
    karaokeUrl: "/songs/karaoke-audio/minik-minik-elleri.mp3",
    lyricsFile: "minik_minik_elleri.md",
    timedLyricsFile: null,
    hasKaraoke: true,
    duration: "2:09",
  },
  {
    id: "no-drug-but-you",
    title: "no drug but you",
    artworkUrl: "/songs/artworks/no-drug-but-you.png",
    audioUrl: "/songs/audio/no-drug-but-you.mp3",
    karaokeUrl: "/songs/karaoke-audio/no-drug-but-you.mp3",
    lyricsFile: "no_drug_but_you.md",
    timedLyricsFile: null,
    hasKaraoke: true,
    duration: "2:43",
  },
  {
    id: "yenilmem-asla",
    title: "Yenilmem Asla! (feat. Güzey)",
    artworkUrl: "/songs/artworks/yenilmem_asla.png",
    audioUrl: "/songs/audio/yenilmem_asla.mp3",
    karaokeUrl: "/songs/karaoke-audio/yenilmem_asla.mp3",
    lyricsFile: "yenilmem_asla.md",
    timedLyricsFile: null,
    hasKaraoke: true,
    duration: "2:22",
  },
  {
    id: "yukselis-ve-dusus",
    title: "Yükseliş & Düşüş (feat. Güzey)",
    artworkUrl: "/songs/artworks/yukselis_ve_dusus.png",
    audioUrl: "/songs/audio/yukselis_ve_dusus.mp3",
    karaokeUrl: "/songs/karaoke-audio/yukselis_ve_dusus.mp3",
    lyricsFile: "yukselis_ve_dusus.md",
    timedLyricsFile: null,
    hasKaraoke: true,
    duration: "3:24",
  },
];

export default musicData;
